import React from 'react';
import { Hero, AskIstatecAI, Services, Products, WhyChooseUs, TechStack, CTA } from '../components/sections';

/**
 * Home Page
 * Main landing page showcasing company services and products
 */
export const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <AskIstatecAI />
      <Services />
      <Products />
      <WhyChooseUs />
      <TechStack />
      <CTA />
    </>
  );
};

